import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Checkbox } from '@/components/ui/checkbox';

import { toast } from 'react-toastify';
import Moment from 'moment';
import { motion } from "framer-motion";
import * as XLSX from 'xlsx';
import Lottie from 'lottie-react';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import animBtnLoading from 'assets/anim/anim-btnLoading.json';

import ServiceSubs from 'services/serviceSubs';
import ServiceOutlet from 'services/serviceOutlet';

export default function PaneOutlet(props) {

    const [records, setRecords] = useState([]);
    const [subs, setSubs] = useState([]);

    const [filter, setFilter] = useState({ 'orgid': props.org.ordid });
    const [tempDoc, setTempDoc] = useState({});

    const [tab, setTab] = useState('all');
    const [query, setQuery] = useState('');
    const [eid, setEid] = useState('');

    const [date, setDate] = useState({
        from: Moment().startOf('month').toDate(),
        to: Moment().toDate(),
    });

    const [pageSize, setPageSize] = useState(10);
    const [pageCurrent, setPageCurrent] = useState(0);
    const [pageTotal, setPageTotal] = useState(0);

    const [isDate, setIsDate] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [submit, setSubmit] = useState(false);
    const [isOrgSame, setIsOrgSame] = useState(false);

    const navigate = useNavigate();
    const subsService = new ServiceSubs();
    const outletService = new ServiceOutlet();

    const outletTypes = [
        { value: 'COSU', label: 'Stand Alone Opration' },
        { value: 'COHQ', label: 'Company HQ' },
        { value: 'COCO', label: 'Company Owned Company Oprated' },
        { value: 'COFO', label: 'Company Owned Franchise Oprated' },
        { value: 'FOCO', label: 'Franchise Owned Company Oprated' },
        { value: 'FOFO', label: 'Franchise Owned Franchise Oprated' },
    ];

    const terminalTypes = [
        { value: 'standard', label: 'Standard Terminal' },
        { value: 'qsr', label: 'QSR Terminal' },
        { value: 'kiosk', label: 'KIOSK Terminal' },
        { value: 'cafe', label: 'Cafe Terminal' },
    ];

    const taxTypes = [
        { value: 'gst18', label: 'GST18' },
        { value: 'gst5', label: 'GST5' },
        { value: 'vat5', label: 'GST5' },
        { value: 'vat3', label: 'VAT3' },
    ];

    const formVSchema = Yup.object().shape({
        name: Yup.string().required('This information is required'),
        tname: Yup.string().required('This information is required'),
        title: Yup.string().required('This information is required'),
        email: Yup.string().required('This information is required').email('Please enter valid email address'),
        phone: Yup.string().required('This information is required').matches(/^\d{10}$/, 'Phone number must be 10 digits'),
        street_1: Yup.string().required('This information is required'),
        street_2: Yup.string().required('This information is required'),
        city: Yup.string().required('This information is required'),
        state: Yup.string().required('This information is required'),
        country: Yup.string().required('This information is required'),
        postal_code: Yup.string().required('This information is required').matches(/^\d{6}$/, 'Phone number must be 10 digits'),
        outlettype: Yup.string().required('This information is required'),
        terminaltype: Yup.string().required('This information is required'),
        subid: Yup.string().required('This information is required'),
    });

    const { values, errors, touched, handleChange, handleSubmit, handleReset, resetForm, setErrors, setValues } = useFormik({
        initialValues: {
            name: '',
            tname: '',
            title: '',
            email: '',
            upi: '',
            phone: '',
            street_1: '',
            street_2: '',
            city: '',
            state: '',
            country: '',
            postal_code: '',
            outlettype: '',
            terminaltype: '',
            subid: '',
            tax: '',
        },
        validationSchema: formVSchema,
        enableReinitialize: true,
        onSubmit: values => {
            if (isEdit) {
                let body = {
                    uid: eid,
                    data: {
                        "subid": values.subid,
                        "outlettype": values.outlettype,
                        "terminaltype": values.terminaltype,
                        "name": values.name,
                        "tradNme": values.tname,
                        "title": values.title,
                        "phone": values.phone,
                        "email": values.email,
                        "upi": values.upi,
                        "tax": getTaxData(values.tax),
                        "addresses": {
                            "title": "Office",
                            "default": true,
                            "street_1": values.street_1,
                            "street_2": values.street_2,
                            "city": values.city,
                            "state": values.state,
                            "country": values.country,
                            "postal_code": values.postal_code,
                        }
                    }
                }
                outletService.updateOutletById(body, props.org.ordid).then((res) => {
                    setSubmit(false);
                    if (res.status) {
                        toast.success("Outlet updated!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                        setTempDoc({});
                        setEid('');
                        setIsEdit(true);
                        setIsOpen(false);
                        setIsOrgSame(false);
                        loadData();
                        props.refresh();
                        handleReset();
                        resetForm();
                    } else {
                        toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    }
                });
            } else {
                let body = {
                    "maincode": props.org.settings.maincode,
                    "subid": values.subid,
                    "outlettype": values.outlettype,
                    "terminaltype": values.terminaltype,
                    "name": values.name,
                    "tradNme": values.tname,
                    "title": values.title,
                    "phone": values.phone,
                    "email": values.email,
                    "upi": values.upi,
                    "tax": getTaxData(values.tax),
                    "addresses": {
                        "title": "Office",
                        "default": true,
                        "street_1": values.street_1,
                        "street_2": values.street_2,
                        "city": values.city,
                        "state": values.state,
                        "country": values.country,
                        "postal_code": values.postal_code,
                    },
                    "status": subs.filter((e) => e.subid === values.subid)[0].status,
                }
                subsService.registerOutlet(body, props.org.ordid).then((res) => {
                    setSubmit(false);
                    if (res.status) {
                        toast.success("Outlet created!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                        setIsOpen(false);
                        setIsOrgSame(false);
                        loadData();
                        props.refresh();
                        handleReset();
                        resetForm();
                    } else {
                        toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    }
                });
            }
        }
    });

    const gotoOutletInfo = (id) => {
        navigate(`/outletInfo/${props.org.ordid}/${id}`);
    }

    const changeTab = (val) => {
        setTab(val);
        setQuery('');
        switch (val) {
            case "all":
                setFilter({ 'orgid': props.org.ordid });
                break;
            case "active":
                setFilter({ 'orgid': props.org.ordid, 'status': 'active' });
                break;
            case "banned":
                setFilter({ 'orgid': props.org.ordid, 'status': 'banned' });
                break;
            default:
                break;
        }
    }

    const handleOnChange = (e) => {
        var { value, name } = e.target;
        switch (name) {
            case 'pageSize':
                setPageSize(value);
                break;
            case 'search':
                setQuery(value);
                break;
        }
    }

    const getTaxData = (type) => {
        switch (type) {
            case 'gst18':
                return {
                    isGST: true,
                    floatingPoint: 2,
                    GSTN: "",
                    Currency: "₹",
                    Food_Percentage: 18,
                    Food_TAX_TYPE: 'overall',
                    Room_Percentage: 0,
                    Room_TAX_TYPE: 'na',
                };
            case 'gst5':
                return {
                    isGST: true,
                    floatingPoint: 2,
                    GSTN: "",
                    Currency: "₹",
                    Food_Percentage: 5,
                    Food_TAX_TYPE: 'overall',
                    Room_Percentage: 0,
                    Room_TAX_TYPE: 'na',
                };
            case 'vat5':
                return {
                    isGST: true,
                    floatingPoint: 2,
                    GSTN: "",
                    Currency: "₹",
                    Food_Percentage: 5,
                    Food_TAX_TYPE: 'overall',
                    Room_Percentage: 0,
                    Room_TAX_TYPE: 'na',
                };
            case 'vat3':
                return {
                    isGST: true,
                    floatingPoint: 2,
                    GSTN: "",
                    Currency: "₹",
                    Food_Percentage: 3,
                    Food_TAX_TYPE: 'overall',
                    Room_Percentage: 0,
                    Room_TAX_TYPE: 'na',
                };
            default:
                return {};
        }
    }

    const getIsTax = (id) => {
        if (id !== "" && id !== undefined) {
            let items = subs.filter((e) => e.subid === id);
            if (items.length === 0) {
                return false;
            } else {
                return items[0].features.isTax;
            }
        }
        return false;
    }

    const toggleSameAs = () => {
        if (!isOrgSame) {
            setValues({
                ...values,
                name: props.org.name,
                tname: props.org.tradNme,
                email: props.org.email,
                phone: props.org.phone,
                street_1: props.org.addresses.length === 0 ? "-" : props.org.addresses[0].street_1,
                street_2: props.org.addresses.length === 0 ? "-" : props.org.addresses[0].street_2,
                city: props.org.addresses.length === 0 ? "-" : props.org.addresses[0].city,
                state: props.org.addresses.length === 0 ? "-" : props.org.addresses[0].state,
                country: props.org.addresses.length === 0 ? "-" : props.org.addresses[0].country,
                postal_code: props.org.addresses.length === 0 ? "-" : props.org.addresses[0].postal_code,
            });
        }
        setIsOrgSame(!isOrgSame);
    }

    const updateStatus = (id, status) => {
        let body = {
            uid: id,
            data: {
                status: status
            }
        }
        outletService.updateOutletById(body, props.org.ordid).then((res) => {
            if (res['status']) {
                loadData();
                props.refresh();
            } else {
                toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }
        });
    }

    const add = () => {
        if (props.data.total > props.data.active) {
            setIsOpen(true);
        } else {
            toast.error('All license are used!', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
        }
    }

    const editRecord = (doc) => {
        setTempDoc(doc);
        setEid(doc._id);
        setIsEdit(true);
        setIsOpen(true);
    }

    const populdata = () => {
        setValues({
            name: tempDoc.name,
            tname: tempDoc.tradNme,
            title: tempDoc.title,
            email: tempDoc.email,
            upi: tempDoc.upi,
            phone: tempDoc.phone,
            street_1: tempDoc.addresses[0].street_1,
            street_2: tempDoc.addresses[0].street_2,
            city: tempDoc.addresses[0].city,
            state: tempDoc.addresses[0].state,
            country: tempDoc.addresses[0].country,
            postal_code: tempDoc.addresses[0].postal_code,
            outlettype: tempDoc.outlettype,
            terminaltype: tempDoc.terminaltype,
            subid: tempDoc.subid,
            tax: '',
        });
    }

    const downloadFile = ({ data, fileName, fileType }) => {
        const blob = new Blob([data], { type: fileType })
        const a = document.createElement('a')
        a.download = fileName
        a.href = window.URL.createObjectURL(blob)
        const clickEvt = new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true,
        })
        a.dispatchEvent(clickEvt)
        a.remove()
    }

    const exportData = (type) => {
        (async function () {
            let body = {
                "filter": filter,
                "page": 0,
                "size": 0,
                "searchQuery": query,
                "startDate": isDate ? date.from.toISOString() : "",
                "endDate": isDate ? Moment(date.to).add(1, 'day').toDate().toISOString() : ""
            };
            var res = await outletService.getAllOutlets(body, props.org.ordid);
            var records = res.data.data;
            let items = [];
            records.forEach((item) => {
                items.push({
                    outletid: item.outletid,
                    orgid: item.orgid,
                    subid: item.subid,
                    outlettype: item.outlettype,
                    terminaltype: item.terminaltype,
                    name: item.name,
                    tradNme: item.tradNme,
                    title: item.title,
                    phone: item.phone,
                    email: item.email,
                    addresses: `${item.addresses.length === 0 ? 'NA' : `${item.addresses[0].street_1}, ${item.addresses[0].street_2} ${item.addresses[0].city}, ${item.addresses[0].state}, ${item.addresses[0].country} - ${item.addresses[0].postal_code}`}`,
                    status: item.status,
                    createdAt: item.createdAt,
                });
            });

            if (type === "xlsx") {
                const worksheet = XLSX.utils.json_to_sheet(items);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "subs");
                XLSX.writeFile(workbook, "Outlet.xlsx");
            } else {
                let headers = ['outletid, orgid, subid, outlettype, terminaltype, name, tradNme, title, phone, email, addresses, status, createdAt'];
                let recordCsv = items.reduce((acc, record) => {
                    const { outletid, orgid, subid, outlettype, terminaltype, name, tradNme, title, phone, email, addresses, status, createdAt } = record
                    acc.push([outletid, orgid, subid, outlettype, terminaltype, name, tradNme, title, phone, email, addresses, status, createdAt].join(','))
                    return acc
                }, []);
                downloadFile({
                    data: [...headers, ...recordCsv].join('\n'),
                    fileName: 'Outlet.csv',
                    fileType: 'text/csv',
                });
            }
        })();
    }

    const loadData = () => {
        (async function () {
            let body = {
                "filter": filter,
                "page": 1,
                "size": parseInt(pageSize),
                "searchQuery": query,
                "startDate": "",
                "endDate": ""
            };
            var res = await outletService.getAllOutlets(body, props.org.ordid);
            if (res['status']) {
                setPageCurrent(res.data.currentPage);
                setPageTotal(res.data.totalPage);
                setRecords(res.data.data);
            } else {
                toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }

            let subBody = {
                "filter": { 'ordid': props.org._id, 'status': 'active' },
                "page": 0,
                "size": 0,
                "searchQuery": "",
                "startDate": "",
                "endDate": ""
            };
            var resSub = await subsService.getAllSubs(subBody, '');
            setSubs(resSub.data.data);
        })();
    }

    const pageChange = (pageValue) => {
        (async function () {
            let body = {
                "filter": filter,
                "page": pageValue,
                "size": parseInt(pageSize),
                "searchQuery": query,
                "startDate": "",
                "endDate": ""
            };
            var res = await outletService.getAllOutlets(body, props.org.ordid);
            if (res['status']) {
                setPageCurrent(res.data.currentPage);
                setPageTotal(res.data.totalPage);
                setRecords(res.data.data);
            } else {
                toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }
        })();
    }

    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        loadData();
    }, [pageSize, query, filter]);

    useEffect(() => {
        if (isOpen && isEdit) {
            populdata();
        }
    }, [isOpen, isEdit, tempDoc]);

    const nextPage = () => {
        if (pageCurrent < pageTotal) {
            pageChange(pageCurrent + 1);
        }
    }

    const prevPage = () => {
        if (pageCurrent > 1) {
            pageChange(pageCurrent - 1);
        }
    }

    return (
        <>
            {
                isOpen && <div className='overflow-y-auto overflow-x-hidden z-[100] w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
                    <div className='bg-white w-[70%] min-h-screen absolute right-0 p-[20px]'>
                        <ScrollArea>
                            <div className='px-2'>
                                <div className='flex items-center justify-between text-2xl'>
                                    <h1 className='font-sans font-medium text-gray-900 uppercase'>{isEdit ? "UPDATE" : "ADD"} OUTLET</h1>
                                    <div className='w-7 h-7 text-gray-700 flex items-center justify-center border border-black rounded-full hover:bg-black hover:text-white cursor-pointer' onClick={() => {
                                        setIsOpen(false);
                                        resetForm();
                                        loadData();
                                        props.refresh();
                                    }}>
                                        <span><i className="las la-times text-xl cursor-pointer"></i></span>
                                    </div>
                                </div>
                                <hr className='my-2' />
                                <form className='mt-4 grid grid-cols-12 gap-3' onSubmit={handleSubmit} onReset={handleReset} noValidate="" autoComplete='off'>
                                    <div className="col-span-4">
                                        <div className='w-full flex items-center'>
                                            <Checkbox checked={isOrgSame} onCheckedChange={(e) => { toggleSameAs(); }} className="mr-2" />
                                            <label className="block text-xs font-medium text-gray-700 font-mono">Same as ORG<sup className="text-red-600">*</sup></label>
                                        </div>
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block mb-2 text-sm font-medium text-gray-600">Outlet Name<sup className="text-red-600">*</sup></label>
                                        <input type="text" id="name" value={values.name} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. Hotel Name" onChange={handleChange} />
                                        {(errors.name && touched.name) && <p className='text-xs text-red-400 mt-1'>{errors.name}</p>}
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block mb-2 text-sm font-medium text-gray-600">Outlet Trade Name<sup className="text-red-600">*</sup></label>
                                        <input type="text" id="tname" value={values.tname} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. Hotel Trade Name" onChange={handleChange} />
                                        {(errors.tname && touched.tname) && <p className='text-xs text-red-400 mt-1'>{errors.tname}</p>}
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block mb-2 text-sm font-medium text-gray-600">Outlet Title<sup className="text-red-600">*</sup></label>
                                        <input type="text" id="title" value={values.title} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. Hotel Trade Name" onChange={handleChange} />
                                        {(errors.title && touched.title) && <p className='text-xs text-red-400 mt-1'>{errors.title}</p>}
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block mb-2 text-sm font-medium text-gray-600">Email Address<sup className="text-red-600">*</sup></label>
                                        <input type="email" id="email" value={values.email} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. jhon.deo@gmail.com" onChange={handleChange} />
                                        {(errors.email && touched.email) && <p className='text-xs text-red-400 mt-1'>{errors.email}</p>}
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block mb-2 text-sm font-medium text-gray-600">UPI Address<sup className="text-gray-600">(Optional)</sup></label>
                                        <input type="upi" id="upi" value={values.upi} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. xxxxxxxxxxx@bank" onChange={handleChange} />
                                        {(errors.upi && touched.upi) && <p className='text-xs text-red-400 mt-1'>{errors.upi}</p>}
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block mb-2 text-sm font-medium text-gray-600">Phone Number<sup className="text-red-600">*</sup></label>
                                        <input type="number" id="phone" value={values.phone} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. xxxxxxxxxx" onChange={handleChange} />
                                        {(errors.phone && touched.phone) && <p className='text-xs text-red-400 mt-1'>{errors.phone}</p>}
                                    </div>

                                    <div className="col-span-12">
                                        <label className="block mb-2 text-sm font-medium text-gray-600">Street Address 1<sup className="text-red-600">*</sup></label>
                                        <input type="text" id="street_1" value={values.street_1} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. Apt, Building " onChange={handleChange} />
                                        {(errors.street_1 && touched.street_1) && <p className='text-xs text-red-400 mt-1'>{errors.street_1}</p>}
                                    </div>

                                    <div className="col-span-12">
                                        <label className="block mb-2 text-sm font-medium text-gray-600">Street Address 2<sup className="text-red-600">*</sup></label>
                                        <input type="text" id="street_2" value={values.street_2} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. Street address, Landmark" onChange={handleChange} />
                                        {(errors.street_2 && touched.street_2) && <p className='text-xs text-red-400 mt-1'>{errors.street_2}</p>}
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block mb-2 text-sm font-medium text-gray-600">City<sup className="text-red-600">*</sup></label>
                                        <input type="text" id="city" value={values.city} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. Mumbai" onChange={handleChange} />
                                        {(errors.city && touched.city) && <p className='text-xs text-red-400 mt-1'>{errors.city}</p>}
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block mb-2 text-sm font-medium text-gray-600">State<sup className="text-red-600">*</sup></label>
                                        <input type="text" id="state" value={values.state} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. Maharashtra" onChange={handleChange} />
                                        {(errors.state && touched.state) && <p className='text-xs text-red-400 mt-1'>{errors.state}</p>}
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block mb-2 text-sm font-medium text-gray-600">Country<sup className="text-red-600">*</sup></label>
                                        <input type="text" id="country" value={values.country} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. India" onChange={handleChange} />
                                        {(errors.country && touched.country) && <p className='text-xs text-red-400 mt-1'>{errors.country}</p>}
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block mb-2 text-sm font-medium text-gray-600">Postal code<sup className="text-red-600">*</sup></label>
                                        <input type="text" id="postal_code" value={values.postal_code} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. xxxxxx" onChange={handleChange} />
                                        {(errors.postal_code && touched.postal_code) && <p className='text-xs text-red-400 mt-1'>{errors.postal_code}</p>}
                                    </div>

                                    <div className="col-span-8"></div>

                                    <div className="col-span-12 font-medium">
                                        Subscription information
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block text-xs font-medium text-gray-700 font-mono">Select Subscription<sup className="text-red-600">*</sup></label>
                                        <select id="subid" className="border-gray-300 border rounded appearance-none w-full py-1 px-2 bg-white mt-2" onChange={handleChange} value={values.type}>
                                            <option value="" disabled="" selected="selected">Select</option>
                                            {
                                                subs.length !== 0 && subs.map((item) => {
                                                    return <option value={item.subid} selected={values.subid == item.subid}>{item.subid}</option>
                                                })
                                            }
                                        </select>
                                        {(errors.subid && touched.subid) && <p className='text-xs text-red-400 mt-1'>{errors.subid}</p>}
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block text-xs font-medium text-gray-700 font-mono">Outlet Type<sup className="text-red-600">*</sup></label>
                                        <select id="outlettype" className="border-gray-300 border rounded appearance-none w-full py-1 px-2 bg-white mt-2" onChange={handleChange} value={values.type}>
                                            <option value="" disabled="" selected="selected">Select</option>
                                            {
                                                outletTypes.length !== 0 && outletTypes.map((item) => {
                                                    return <option value={item.value} selected={values.outlettype == item.value}>{item.label}</option>
                                                })
                                            }
                                        </select>
                                        {(errors.outlettype && touched.outlettype) && <p className='text-xs text-red-400 mt-1'>{errors.outlettype}</p>}
                                    </div>

                                    <div className="col-span-4">
                                        <label className="block text-xs font-medium text-gray-700 font-mono">Terminal Type<sup className="text-red-600">*</sup></label>
                                        <select id="terminaltype" className="border-gray-300 border rounded appearance-none w-full py-1 px-2 bg-white mt-2" onChange={handleChange} value={values.type}>
                                            <option value="" disabled="" selected="selected">Select</option>
                                            {
                                                terminalTypes.length !== 0 && terminalTypes.map((item) => {
                                                    return <option value={item.value} selected={values.terminaltype == item.value}>{item.label}</option>
                                                })
                                            }
                                        </select>
                                        {(errors.terminaltype && touched.terminaltype) && <p className='text-xs text-red-400 mt-1'>{errors.terminaltype}</p>}
                                    </div>

                                    {
                                        getIsTax(values.subid) && <div className="col-span-4">
                                            <label className="block text-xs font-medium text-gray-700 font-mono">Tax Settings<sup className="text-red-600">*</sup></label>
                                            <select id="tax" className="border-gray-300 border rounded appearance-none w-full py-1 px-2 bg-white mt-2" onChange={handleChange} value={values.type}>
                                                <option value="" disabled="" selected="selected">Select</option>
                                                {
                                                    taxTypes.length !== 0 && taxTypes.map((item) => {
                                                        return <option value={item.value} selected={values.tax == item.value}>{item.label}</option>
                                                    })
                                                }
                                            </select>
                                            {(errors.tax && touched.tax) && <p className='text-xs text-red-400 mt-1'>{errors.tax}</p>}
                                        </div>
                                    }

                                    <div className='col-span-12 my-6'>
                                        <div className='flex items-end'>
                                            <button type="submit" className="text-white bg-prime hover:bg-primeLight focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center" disabled={submit}>
                                                {submit && <Lottie animationData={animBtnLoading} className="w-8 h-8" loop={true} />}
                                                {!submit && "SAVE"}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </ScrollArea >
                    </div >
                </div >
            }
            <div className="w-full min-h-[400px]">
                <div className="col-span-12">
                    <div className="w-full shadow-md rounded-md border p-2">
                        <div class="w-full flex justify-between items-center">
                            <div className='h-10 bg-gray-100 rounded'>
                                <ul className="intro-y flex text-sm font-sans">
                                    <li className={`px-3 h-6 m-2 rounded flex items-center justify-center ${tab === 'all' ? 'text-red-600 font-medium bg-white shadow' : 'text-asent font-medium'}`}><button className='' onClick={() => { changeTab('all') }}>All</button></li>
                                    <li className={`px-3 h-6 m-2 rounded flex items-center justify-center ${tab === 'active' ? 'text-red-600 font-medium bg-white shadow' : 'text-asent font-medium'}`}><button className='' onClick={() => { changeTab('active') }}>Active</button></li>
                                    <li className={`px-3 h-6 m-2 rounded flex items-center justify-center ${tab === 'banned' ? 'text-red-600 font-medium bg-white shadow' : 'text-asent font-medium'}`}><button className='' onClick={() => { changeTab('banned') }}>In-Active</button></li>
                                </ul>
                            </div>
                            <button className="h-8 py-1 px-2 rounded-md bg-prime hover:bg-primeLight text-white mr-2 text-sm" onClick={() => { add() }}><i class="las la-plus mr-1"></i> ADD OUTLET</button>
                        </div>
                        <table className="min-w-full divide-y divide-gray-200 px-4 mt-2">
                            <thead className="bg-gray-50">
                                <tr className=''>
                                    <th scope="col" className="border-b border-gray-200" colSpan={9}>
                                        <div className='w-full p-2 flex items-center'>
                                            <div className='flex items-center'>
                                                <DropdownMenu>
                                                    <DropdownMenuTrigger>
                                                        <button className="w-[140] py-1 px-3 h-10 rounded-md bg-prime hover:bg-primeLight text-white text-base font-normal"><i className="las la-file-download"></i> Export</button>
                                                    </DropdownMenuTrigger>
                                                    <DropdownMenuContent>
                                                        <div
                                                            className='bg-white shadow-md rounded-md absolute' style={{ top: '0px', left: '-64px' }}>
                                                            <div>
                                                                <ul className='flex flex-col items-start p-2'>
                                                                    <DropdownMenuItem>
                                                                        <li className="w-40 cursor-pointer p-2 rounded-md" onClick={() => {
                                                                            exportData('xlsx');
                                                                        }}>
                                                                            <div className='flex items-center text-base'>
                                                                                <p className="text-sm font-serif ml-2 font-normal">Export to .xlsx</p>
                                                                            </div>
                                                                        </li>
                                                                    </DropdownMenuItem>
                                                                    <DropdownMenuItem>
                                                                        <li className="w-40 cursor-pointer p-2 rounded-md" onClick={() => {
                                                                            exportData('csv');
                                                                        }}>
                                                                            <div className='flex items-center text-base'>
                                                                                <p className="text-sm font-serif ml-2 font-normal">Export to .csv</p>
                                                                            </div>
                                                                        </li>
                                                                    </DropdownMenuItem>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </DropdownMenuContent>
                                                </DropdownMenu>
                                            </div>
                                            <form className="ml-2 items-center py-2 grid grid-cols-12 gap-2 flex-grow">
                                                <div className='w-full flex col-span-12 items-center'>
                                                    <div className='w-[80px]'>
                                                        <p>Search :</p>
                                                    </div>
                                                    <input type="text" value={query} onChange={handleOnChange} name='search' placeholder="Search by id" className="w-full h-10 px-4 font-sans text-sm outline-none rounded border" />
                                                </div>
                                            </form>
                                        </div>
                                    </th>
                                </tr>
                                <tr>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                        OUTLET ID
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                        SUB ID
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                        Trade Names
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                        Contact Details
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                        Outlet Type
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                        Terminal Type
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                        Status
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                        Created At
                                    </th>
                                    <th scope="col" className="px-2 py-3"></th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {
                                    records.length !== 0 && records.map((rec) => {
                                        return <tr className="hover:bg-gray-100" key={rec._id}>
                                            <td className="px-6 py-4 whitespace-nowrap cursor-pointer" onClick={() => { gotoOutletInfo(rec.outletid); }}>
                                                <div className="text-sm font-bold text-gray-900">
                                                    <div className='flex items-center text-prime uppercase'>
                                                        {rec.outletid}
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm font-bold text-gray-900 uppercase">
                                                    <div>{rec.subid}</div>
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm font-bold text-gray-900">
                                                    <div>Name: {rec.name}</div>
                                                    <div>Trade Name: {rec.tradNme}</div>
                                                    <div>Title: {rec.title}</div>
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm font-bold text-gray-900">
                                                    <div>Email Id: {rec.email}</div>
                                                    <div>Phone Number: {rec.phone}</div>
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm font-bold text-gray-900 uppercase">
                                                    <div>{rec.outlettype}</div>
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm font-bold text-gray-900 uppercase">
                                                    <div>{rec.terminaltype}</div>
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full uppercase ${rec.status == 'active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                                                    {rec.status.toUpperCase()}
                                                </span>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm font-bold text-gray-900">
                                                    <div>{Moment(rec.endDate).format('DD, MMM yyyy')}</div>
                                                </div>
                                            </td>
                                            <td>
                                                <DropdownMenu>
                                                    <DropdownMenuTrigger>
                                                        <motion.i whileHover={{ scale: 1.1 }} class="las la-ellipsis-v text-lg"></motion.i>
                                                    </DropdownMenuTrigger>
                                                    <DropdownMenuContent>
                                                        <div>
                                                            <ul className='flex flex-col items-start'>
                                                                <DropdownMenuItem>
                                                                    <li className='w-32 cursor-pointer rounded-md' onClick={() => {
                                                                        editRecord(rec);
                                                                    }}>
                                                                        <div className='flex items-center text-base'>
                                                                            <i className="las la-edit text-lg"></i>
                                                                            <p className='text-sm font-serif ml-2'>Edit</p>
                                                                        </div>
                                                                    </li>
                                                                </DropdownMenuItem>
                                                                {
                                                                    rec.status == 'active' && <DropdownMenuItem>
                                                                        <li className='w-32 cursor-pointer rounded-md' onClick={() => {
                                                                            updateStatus(rec._id, 'banned');
                                                                        }}>
                                                                            <div className='flex items-center text-base'>
                                                                                <i className="las la-ban text-lg"></i>
                                                                                <p className='text-sm font-serif ml-2'>Block</p>
                                                                            </div>
                                                                        </li>
                                                                    </DropdownMenuItem>
                                                                }
                                                                {
                                                                    rec.status == 'banned' && <DropdownMenuItem>
                                                                        <li className='w-32 cursor-pointer rounded-md' onClick={() => {
                                                                            updateStatus(rec._id, 'active');
                                                                        }}>
                                                                            <div className='flex items-center text-base'>
                                                                                <i className="las la-chevron-circle-up text-lg"></i>
                                                                                <p className='text-sm font-serif ml-2'>Active</p>
                                                                            </div>
                                                                        </li>
                                                                    </DropdownMenuItem>
                                                                }
                                                                {
                                                                    rec.status == 'banned' && <DropdownMenuItem>
                                                                        <li className='w-32 cursor-pointer rounded-md' onClick={() => {
                                                                            updateStatus(rec._id, 'deleted');
                                                                        }}>
                                                                            <div className='flex items-center text-base'>
                                                                                <i className="las la-trash text-lg"></i>
                                                                                <p className='text-sm font-serif ml-2'>Delete</p>
                                                                            </div>
                                                                        </li>
                                                                    </DropdownMenuItem>
                                                                }
                                                            </ul>
                                                        </div>
                                                    </DropdownMenuContent>
                                                </DropdownMenu>
                                            </td>
                                        </tr>
                                    })
                                }
                                {
                                    records.length === 0 && <tr className="cursor-pointer hover:bg-gray-100">
                                        <td className="px-6 py-4 whitespace-nowrap" colSpan="9">
                                            <div className="text-sm text-red-600 text-center">
                                                No data found.
                                            </div>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table >
                        <div className='flex py-2 px-4 items-center bg-blue-50'>
                            <p className='text-sm font-serif'>Show rows per page</p>
                            <select className='text-sm ml-2 bg-gray-100' name="pageSize" onChange={handleOnChange} value={pageSize}>
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                                <option value={40}>40</option>
                                <option value={50}>50</option>
                            </select>
                            <div className='flex-grow'></div>
                            <p className='text-sm font-serif mr-2'>Page {pageCurrent} of {pageTotal}</p>
                            <div onClick={() => { prevPage() }}><i className={`las la-angle-left w-6 h-6 flex items-center justify-center rounded-full hover:bg-gray-200 ${pageCurrent <= 1 ? 'text-gray-400 cursor-not-allowed' : 'text-black cursor-pointer'}`}></i></div>
                            <div onClick={() => { nextPage() }}><i className={`las la-angle-right w-6 h-6 flex items-center justify-center rounded-full hover:bg-gray-200 ml-2 text-black ${pageCurrent === pageTotal ? 'text-gray-400 cursor-not-allowed' : 'text-black cursor-pointer'}`}></i></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}